module.exports = __webpack_public_path__ + "img/desburocratizacao_prata.be933208.png";